<div class="landing-wrapper">
  <div class="overlay"></div>

  <div class="landing-content">
    <h1>STOCK MANAGEMENT SYSTEM</h1>

    <div class="form-row">
      <ds-form-field class="form-control">
        <label ds-label for="dropdown1" class="form-label"
          >Preferred Dealership</label
        >
        <ds-select
          id="dropdown1"
          [labellingConfig]="{ placeholder: 'Select your dealership' }"
          [options]="dealerOptions"
          [(ngModel)]="selectedDealer"
          required
        ></ds-select>
      </ds-form-field>

      <ds-button
        type="button"
        appearance="primary"
        class="continue-btn"
        (click)="enterApp()"
      >
        Continue
      </ds-button>
    </div>
  </div>
</div>
